import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';

export default class LP extends BaseLP {
    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfDominatorStacks', preparedPlayers.groupedBy.property('dominator')));
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('prepareSectionByPlayer', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec('projectedOwnership', {}, ''),
            projectedOwnershipForce: this.exec(
                'forceOfProjectedOwnership',
                {
                    filterByPositions: false,
                },
                '',
            ),
            positions: this.exec('prepareSectionByPosition', {}, ''),
            teams: this.exec('prepareSectionByTeam', {}, ''),
            dominatorStacks: this.exec('prepareSectionByDominatorStack', {}, ''),
        };
        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };
        return {...constraints};
    }
}
